module.exports = __webpack_public_path__ + "static/media/bt-containers.cf8229b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/bt-containers.png
// module id = 668
// module chunks = 0